import { Component, OnInit } from '@angular/core';
import { DocumentationUrlsModel } from 'src/app/@core/models/infrastructure/DocumentationUrlsModel.model';
import { DarkModeService } from 'src/app/@core/services/dark-mode/dark-mode.service';
import { InfrastructureService } from 'src/app/@core/services/infrastructure/infrastructure.service';

@Component({
  selector: 'app-documentation-url',
  templateUrl: './documentation-url.component.html',
  styleUrls: ['./documentation-url.component.scss']
})
export class DocumentationUrlComponent implements OnInit {

  documents: DocumentationUrlsModel

  constructor(private infraService: InfrastructureService, public darkModeService: DarkModeService) { }

  ngOnInit(): void {
    if (!this.documents) {
      this.infraService.getDocumentationUrls().subscribe((documents) => {
        this.documents = documents;
      });
    }
  }

  goToUrl(url){
    window.open(url);
  }
}
